import { useEffect, useState } from "react";
import { toast } from "sonner";
import { adminApi, formatApiError } from "../lib/api";
import { useSeo } from "../components/site/Layout";

const FIELDS = [
  ["phone", "Téléphone affiché sur le site", "Laisser vide pour n'afficher aucun numéro."],
  ["host_name", "Hébergeur (nom)", "Affiché dans les mentions légales."],
  ["host_address", "Hébergeur (coordonnées)", ""],
  ["mediator", "Médiateur de la consommation", "Affiché dans les CGV."],
];

export default function AdminSettings() {
  useSeo("Paramètres — admin");
  const [v, setV] = useState(null);
  useEffect(() => { adminApi.get("/settings").then((r) => setV(r.data)); }, []);
  const save = async (e) => {
    e.preventDefault();
    try { const r = await adminApi.put("/settings", { phone: v.phone, host_name: v.host_name, host_address: v.host_address, mediator: v.mediator }); setV(r.data); toast.success("Paramètres enregistrés"); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
  };
  if (!v) return <p className="text-slate-600">Chargement…</p>;
  return (
    <form onSubmit={save} className="max-w-2xl space-y-6" data-testid="admin-settings">
      <h1 className="text-3xl sm:text-4xl">Paramètres du site</h1>
      {FIELDS.map(([k, l, h]) => (
        <label key={k} className="block"><span className="font-semibold text-navy">{l}</span>
          {h && <span className="block text-sm text-slate-600">{h}</span>}
          <input className="field-input mt-2" value={v[k] || ""} onChange={(e) => setV({ ...v, [k]: e.target.value })} data-testid={`settings-${k}`} />
        </label>
      ))}
      <button type="submit" className="btn-primary" data-testid="settings-save">Enregistrer</button>
    </form>
  );
}
